export default __webpack_public_path__ + "static/media/h2-1.fe95ab8d.jpg";